(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tabs-content"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('variant-box-contents')) {
    customElements.define(
      'variant-box-contents',
      class VariantBoxContents extends HTMLElement {
        connectedCallback() {
          this.output = this.querySelector('[data-variant-box-output]');
          this.fallback = this.querySelector('[data-product-box-fallback]');
          this.variantTemplates = new Map(
            [...this.querySelectorAll('template[data-variant-box-template]')].map((template) => [
              template.dataset.variantId,
              template
            ])
          );

          this.subscribeToVariantChanges = () => {
            if (!window.FoxTheme?.pubsub || this.unsubscribe) return;
            this.unsubscribe = FoxTheme.pubsub.subscribe(
              FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange,
              ({ data }) => this.update(data.variant?.id)
            );
          };

          if (document.readyState === 'complete') {
            this.subscribeToVariantChanges();
          } else {
            window.addEventListener('load', this.subscribeToVariantChanges, { once: true });
          }
        }

        disconnectedCallback() {
          window.removeEventListener('load', this.subscribeToVariantChanges);
          this.unsubscribe?.();
        }

        update(variantId) {
          if (!this.output || !variantId) return;
          const template = this.variantTemplates.get(String(variantId)) || this.fallback;
          if (!template) return;
          this.output.replaceChildren(template.content.cloneNode(true));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
